<template>
  <div class="question-itemInfo">
    <div
      class="top row-between"
      :style="{ 'border-radius': !showDes ? '6px' : '6px 6px 0 0' }"
    >
      <div class="name row">
        <div
          :class="[
            'name-max',
            'text-wrap',
            itemInfo.errorType == 1 ? 'name_error' : '',
          ]"
        >
          {{ itemName2[language] }}
        </div>
        <div class="icon-button1">
          <svg-icon
            iconClass="arrow-right-circle"
            style="width: 22px; height: 22px"
            v-if="!showDes"
            @click="showDes = true"
          ></svg-icon>
          <svg-icon
            iconClass="arrow-up-circle"
            style="width: 22px; height: 22px"
            v-if="showDes"
            @click="showDes = false"
          ></svg-icon>
        </div>
      </div>

      <div
        style="display: flex; flex-direction: column; align-items: flex-end"
        v-if="itemInfo.isWrong"
      >
        <div class="row">
          <div
            class="icon-button center"
            @click="clickOpen(4, ['damages', index, 'photo'])"
          >
            <svg-icon
              style="width: 1.75rem; height: 1.75rem"
              iconClass="photograph_normal"
            ></svg-icon>
            <span
              class="little-icon"
              :style="itemInfo.img?.length == 1 ? 'width:14px;height:14px' : ''"
              v-if="itemInfo.img?.length >= 1"
              >{{ itemInfo.img?.length > 1 ? itemInfo.img?.length : "" }}</span
            >
          </div>
          <div
            class="icon-button center"
            style="margin-left: 14px"
            @click="clickOpen(3, ['damages', index, 'message'])"
          >
            <svg-icon
              style="width: 1.375rem; height: 1.375rem"
              iconClass="edit_normal"
            ></svg-icon>
            <span
              class="little-icon"
              style="width: 14px; height: 14px"
              v-if="itemInfo.notes"
            ></span>
          </div>
          <div style="margin-left: 14px; position: relative; top: 2px">
            <svg-icon
              style="width: 1.4rem; height: 1.4rem"
              iconClass="close"
              @click="clearWrong"
            ></svg-icon>
          </div>
        </div>
      </div>
      <div
        class="successStatus"
        v-if="!itemInfo.isWrong"
        @click="itemInfo.isWrong = true"
      ></div>
    </div>

    <div
      style="
        margin: 6px 0;
        color: #ea0000;
        font-size: 14px;
        display: flex;
        justify-content: flex-end;
      "
      v-if="itemInfo.errorType == 1"
    >
      {{ stringList.comments_required }}
    </div>
    <div class="bottom text-wrap" v-if="showDes">
      {{ itemQuestions2[language] }}
    </div>

    <a-modal
      v-model="visible"
      :style="{ display: !modalShow ? 'none' : '' }"
      :title="null"
      :footer="null"
      :closable="false"
      :width="320"
      :maskClosable="type != 1"
      wrapClassName="all-modal"
      :bodyStyle="{ 'border-radius': '16px', background: '#fff' }"
      @cancel="visible = false"
    >
      <svg-icon
        class="modal-delete_x ceshi"
        style="width: 14px; height: 14px; fill: #767676"
        iconClass="delete_x"
        className="icons/svg/delete_x.svg"
        @click="visible = false"
      ></svg-icon>
      <!-- 编辑 -->
      <Comments
        v-if="type == 3"
        v-model="itemInfo.notes"
        @close="visible = false"
      ></Comments>
      <!-- 拍照 -->
      <uploadImg
        ref="photo"
        v-if="type == 4"
        v-model="itemInfo.img"
        @closed="closed"
        @open="visible = true"
      >
        <template #left>
          <svg-icon
            style="width: 11.5px; height: 22px; transform: rotate(180deg)"
            iconClass="right"
            className="icons/svg/right.svg"
          ></svg-icon>
        </template>
        <template #right>
          <svg-icon
            style="width: 11.5px; height: 22px"
            iconClass="right"
            className="icons/svg/right.svg"
          ></svg-icon>
        </template>
        <template #submit>
          <svg-icon
            style="width: 0.875rem; height: 0.875rem"
            iconClass="add_white"
            className="icons/svg/add_white.svg"
          ></svg-icon>
          <svg-icon
            style="width: 1.75rem; height: 1.5rem; margin-left: 10px"
            iconClass="photograph_white"
            className="icons/svg/photograph_white.svg"
          ></svg-icon>
        </template>
        <template #delete>
          <svg-icon
            style="width: 1.375rem; height: 1.375rem"
            iconClass="delete"
            className="icons/svg/delete.svg"
          ></svg-icon> </template
      ></uploadImg>
    </a-modal>
  </div>
</template>

<script>
import Comments from "@/components/Comments.vue";
import uploadImg from "@/components/UploadImg.vue";
import { mapGetters } from "vuex";

export default {
  name: "QuestionItem",
  components: {
    Comments,
    uploadImg,
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    roomNumber: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      itemInfo: {},
      visible: false,
      modalShow: false,
      type: 0,
      getValue: [],
      roomType: undefined,
      currentVisible: [],
      showDes: false,
      img: [],
      itemName2: {},
      itemQuestions2: {},
    };
  },
  computed: {
    ...mapGetters({
      stringList: "stringList",
      userInfo: "userInfo",
      language: "language",
    }),
  },
  watch: {
    item: {
      handler(newValue) {
        this.itemInfo = newValue;

        if (newValue.itemName2) {
          this.itemName2 = JSON.parse(newValue.itemName2);
          this.itemQuestions2 = JSON.parse(newValue.itemQuestions2);
        }
      },
      deep: true,
      immediate: true,
    },
    itemInfo: {
      handler(newValue) {
        this.$emit("update:item", newValue);
      },
      deep: true,
    },
  },
  methods: {
    clickOpen(type, nameList) {
      if (nameList) {
        this.currentVisible = nameList;
      } else {
        this.currentVisible = [];
      }
      this.type = type;
      this.visible = true;
      this.modalShow = true;
      if (type == 4 && (!this.itemInfo.img || this.itemInfo.img.length == 0)) {
        this.modalShow = false;
        this.$nextTick(() => {
          this.$refs.photo.uploadImg();
        });
      }
    },
    closed() {
      this.visible = false;
    },

    clearWrong() {
      this.itemInfo.isWrong = false;
      this.itemInfo.errorType = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.question-itemInfo {
  width: 100%;
  margin-bottom: 16px;

  .top {
    width: 100%;
    padding: 15px 12px;
    background: #ededed;
    .name {
      flex: 1;
      flex-shrink: 0;
      &-max {
        max-width: 80%;
        font-size: 16px;
        line-height: 1.2;
        color: #101010;
        text-align: left;
      }

      .icon-button1 {
        margin-left: 4px;
        flex-shrink: 0;
      }
    }

    .name_error {
      color: #cb4e4e !important;
      font-weight: bold !important;
    }
  }
}

.icon-button {
  flex-shrink: 0;
  border-radius: 12px;
  position: relative;

  .required {
    position: absolute;
    left: -9px;
    top: 6px;
    font-size: 18px;
  }

  .little-icon {
    position: absolute;
    top: -6px;
    right: -8px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    opacity: 1;
    font-family: Arial;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    background: #ff6600;
    border: 2px solid #ffffff;
  }
}

.bottom {
  border-top: 1px solid #ffffff;
  padding: 12px;
  background-color: #ededed;

  font-size: 14px;
  line-height: 18px;
  color: #3d3d3d;
  text-align: left;
  border-radius: 0 0 6px 6px;
}

.successStatus {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4bca02;
}
</style>
